import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface BackofficeCompanyDetailData {
  companyName: string;
  companyAbbreviation: string;
  companyId: number;
  companyObservation: string;
  companyLogo: string;
}

export interface BackofficeCompanyDetailState {
  status: number;
  message: string;
  path: string;
  data: BackofficeCompanyDetailData;
}

const initialState: BackofficeCompanyDetailState = {
  status: 0,
  message: '',
  path: '',
  data: {
    companyName: '',
    companyAbbreviation: '',
    companyId: 0,
    companyObservation: '',
    companyLogo: '',
  },
};

export const backofficeCompanySlice = createSlice({
  name: 'backofficeCompanyDetail',
  initialState,
  reducers: {
    handleData: (
      state,
      action: PayloadAction<BackofficeCompanyDetailState>,
    ) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
      state.path = action.payload.path;
      state.data = action.payload.data;
    },
  },
});

export const { handleData } = backofficeCompanySlice.actions;
